"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _Logger = _interopRequireDefault(require("./Logger"));
/**
 * Copyright 2016-present, Deloitte Digital.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * Registration
 */
var Registration = /*#__PURE__*/function () {
  function Registration(operator) {
    (0, _classCallCheck2.default)(this, Registration);
    /**
     * Operator reference
     * @type {function}
     * @private
     */
    this._operator = operator;

    /**
     * The registration key
     * @type {string}
     * @private
     */
    this._key = null;

    /**
     * Registration meta data
     * @type {object}
     * @private
     */
    this._meta = {};
  }

  /**
   * The registration operator
   * @returns {Function}
   */
  (0, _createClass2.default)(Registration, [{
    key: "operator",
    get: function get() {
      return this._operator;
    }

    /**
     * The registration key
     * @returns {string|*}
     */
  }, {
    key: "key",
    get: function get() {
      return this._key;
    }

    /**
     * The registration meta data
     * @returns {Object}
     */
  }, {
    key: "meta",
    get: function get() {
      return this._meta;
    }

    /**
     * Set the registration key, must be unique
     * @param {string}  key     - The key
     * @returns {Registration}
     */
  }, {
    key: "as",
    value: function as(key) {
      if (typeof key !== 'string') {
        _Logger.default.error('RHE13', 'Unexpected key type. Expected a string.', key);
        return;
      }
      this._key = key;
      return this;
    }

    /**
     * Set the registration default props
     * @param {object}      props       - The default props
     * @returns {Registration}
     */
  }, {
    key: "withDefaultProps",
    value: function withDefaultProps(props) {
      this._meta.defaultProps = props;
      return this;
    }

    /**
     * Set the habitat options
     * @param {object}      options                     - The habitat options
     * @param {string}      [options.tag]               - The tag to use eg 'span'
     * @param {string}      [options.className]         - The habitats class name
     * @param {boolean}     [options.replaceDisabled]   - If true, the original node will be left in the dom
     * @returns {Registration}
     */
  }, {
    key: "withOptions",
    value: function withOptions(options) {
      this._meta.options = options;
      return this;
    }
  }]);
  return Registration;
}();
exports.default = Registration;